import React, { FC } from 'react'
import { Input } from 'reactstrap'

type Props = {
    generateWaArString: () => string
}

export const WAAssignmentsTab: FC<Props> = ({ generateWaArString }) => {

    return (
        <div>
            <p className="small">
                {"Lists the individual timers for each player. Mainly used as input for other tools."}
            </p>

            <Input
                type="textarea"
                readOnly={true}
                value={generateWaArString()}
                style={{
                    fontFamily: "monospace",
                    fontSize: "12px",
                    minHeight: "300px"
                }}
            />
        </div>
    )
}
